<script>
  import {previewUrlForPlaylist} from "./services/imageService";
  import {update_playlist} from "./Utils/RouterUtils.svelte"
  import DiffilcultyBadge from "./DiffilcultyBadge.svelte";

  export let playlist = null
  import {fade} from 'svelte/transition';
  import CardImage from "./CardImage.svelte";
  import CardBody from "./CardBody.svelte";
  import CardTitle from "./CardTitle.svelte";
  import CardDescription from "./CardDescription.svelte";
  

  function backtotop() {
    let section = document.getElementById('tutorialBrowserTop');
    let sectionTop = section.offsetTop;
    window.scrollTo({
        top: sectionTop,
        behavior: "smooth"
    });
  }

</script>

<style>
    .card {
        border: none;
        background: none;
    }

    .card-body {
        padding: 0.6rem;
    }

    h4 {
        padding-bottom: 0;
        padding-top: 10px;
    }

    .card-body p {
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        display: block;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
    }

    img {
        cursor: pointer;
    }
</style>

<div
  id={playlist.slug.current}
  in:fade="{{delay: 0,  duration: 200}}"
  on:click={update_playlist(playlist.slug.current), backtotop}
  class="vec-flex vec-flex-col vec-space-y-4"
>
    <!-- <Debug value={playlist} /> -->
  <CardImage src="{previewUrlForPlaylist(playlist)}" alt="{playlist.title}" />
  <CardBody>
    <CardTitle>{playlist.title}</CardTitle>
    <DiffilcultyBadge difficulty={playlist.difficulty} />
    <CardDescription>{playlist.description}</CardDescription>
  </CardBody>
</div>
